import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function PortfolioAtRiskReport() {
  return <ReportForm reportAPI={ ReportAPI.PORTFOLIO_AT_RISK } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/PortfolioAtRiskReport.js